export const translations = {
  es: {
    nav: {
      approach: "Enfoque",
      services: "Servicios",
      reach: "Cobertura",
      payments: "Pagos",
      contact: "Contacto",
      call: "Llámanos",
      cta: "Agenda una consulta",
    },
    hero: {
      kicker: "Estrategia Administrativa & Fiscal · LATAM",
      line1: "Arquitectura",
      line2: "financiera para",
      line3: "patrimonios sin",
      line4: "fronteras.",
      sub: "FLODELICA diseña estrategias administrativas y fiscales a la medida para clientes y empresas en toda Latinoamérica. Estructura, cumplimiento y crecimiento con discreción absoluta.",
      ctaPrimary: "Iniciar estrategia",
      ctaSecondary: "Conocer el enfoque",
      stat1: "18",
      stat1l: "Países en LATAM",
      stat2: "+320",
      stat2l: "Estructuras diseñadas",
      stat3: "100%",
      stat3l: "Confidencialidad",
    },
    marquee: "ESTRATEGIAS FISCALES · WEALTH MANAGEMENT · LATAM · CORPORATE ADVISORY · ESTRUCTURACIÓN · CUMPLIMIENTO ·",
    approach: {
      label: "El Manifiesto",
      title: "Un enfoque construido sobre precisión, no plantillas.",
      chapters: [
        { n: "01", t: "Diagnóstico profundo", d: "Analizamos tu estructura actual, tus flujos y tu exposición fiscal antes de proponer una sola línea de estrategia." },
        { n: "02", t: "Diseño a la medida", d: "Cada estructura administrativa y fiscal se construye alrededor de tus objetivos patrimoniales y tu jurisdicción." },
        { n: "03", t: "Implementación blindada", d: "Ejecutamos con cumplimiento normativo estricto en cada país de LATAM donde operas." },
        { n: "04", t: "Acompañamiento continuo", d: "No entregamos un documento y desaparecemos. Optimizamos tu estrategia trimestre tras trimestre." },
      ],
    },
    services: {
      label: "Servicios",
      title: "Estrategias que protegen, ordenan y multiplican tu patrimonio.",
      items: [
        { t: "Estrategia Fiscal", d: "Optimización tributaria legal, planeación fiscal internacional y reducción de carga impositiva conforme a la normativa de cada jurisdicción." },
        { t: "Estructura Administrativa", d: "Rediseño de procesos, gobierno corporativo y estructuras societarias eficientes para operar sin fricción en LATAM." },
        { t: "Cumplimiento & Compliance", d: "Prevención de riesgos, obligaciones regulatorias y reportes en regla ante autoridades locales e internacionales." },
        { t: "Wealth & Sucesión", d: "Protección patrimonial, vehículos de inversión y planeación sucesoria para preservar el legado familiar." },
      ],
    },
    reach: {
      label: "Cobertura Regional",
      title: "Una sola firma. Todo Latinoamérica.",
      body: "Operamos con conocimiento local en las principales jurisdicciones de la región. Donde tu capital se mueve, nuestra estrategia lo acompaña.",
      countries: ["México", "Colombia", "Chile", "Perú", "Argentina", "Brasil", "Panamá", "Uruguay"],
    },
    payments: {
      label: "Formas de Pago",
      title: "Liquida honorarios y estrategias con total flexibilidad.",
      body: "Aceptamos múltiples métodos de pago internacionales. Selecciona el que mejor se adapte a tu operación.",
      cards: {
        t: "Tarjetas",
        d: "Cobramos con Visa, Mastercard y American Express a través de un link de pago seguro que enviamos directamente a ti.",
        tag: "Vía link de pago",
      },
      wire: {
        t: "Transferencia Internacional",
        d: "Recibimos transferencias internacionales (SWIFT/Wire). Compartimos los datos bancarios completos al confirmar tu estrategia.",
        tag: "SWIFT / Wire",
      },
      crypto: {
        t: "Criptomonedas",
        d: "También cobramos con criptomonedas. Aceptamos las principales redes y compartimos la dirección de billetera correspondiente.",
        tag: "BTC · ETH · USDT",
      },
      note: "* Todos los pagos se procesan de forma privada tras confirmar el alcance de la estrategia. Esta sección es únicamente informativa.",
    },
    contact: {
      label: "Contacto",
      title: "Comienza tu estrategia.",
      body: "Cuéntanos sobre tu situación. Un asesor senior de FLODELICA te contactará de forma confidencial.",
      phoneLabel: "Teléfono",
      emailLabel: "Correo",
      addressLabel: "Domicilio",
      address: "Calle 32 Ext. 269, Col. Montes de Amé, Mérida, Yucatán, C.P. 97115",
      intlNote: "Atendemos llamadas internacionales desde cualquier país de LATAM y el mundo.",
      phone: "+52 999 592 7397",
      phoneHref: "+529995927397",
      emailValue: "info@flodelicafiscal.com",
      name: "Nombre completo",
      email: "Correo electrónico",
      country: "País",
      company: "Empresa (opcional)",
      service: "Servicio de interés",
      selectService: "Selecciona un servicio",
      message: "Cuéntanos sobre tu objetivo",
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success: "Solicitud enviada. Te contactaremos pronto.",
      error: "Ocurrió un error. Inténtalo de nuevo.",
      services: ["Estrategia Fiscal", "Estructura Administrativa", "Cumplimiento & Compliance", "Wealth & Sucesión"],
    },
    footer: {
      tagline: "Estrategia administrativa y fiscal para patrimonios sin fronteras.",
      rights: "Todos los derechos reservados.",
      confidential: "Firma privada de asesoría · LATAM",
      pay: "Pagos aceptados",
      terms: "Términos y Condiciones",
      privacy: "Aviso de Privacidad",
    },
  },
  en: {
    nav: {
      approach: "Approach",
      services: "Services",
      reach: "Coverage",
      payments: "Payments",
      contact: "Contact",
      call: "Call us",
      cta: "Book a consultation",
    },
    hero: {
      kicker: "Administrative & Tax Strategy · LATAM",
      line1: "Financial",
      line2: "architecture for",
      line3: "wealth without",
      line4: "borders.",
      sub: "FLODELICA designs bespoke administrative and tax strategies for clients and companies across Latin America. Structure, compliance and growth with absolute discretion.",
      ctaPrimary: "Start your strategy",
      ctaSecondary: "Explore the approach",
      stat1: "18",
      stat1l: "Countries in LATAM",
      stat2: "+320",
      stat2l: "Structures designed",
      stat3: "100%",
      stat3l: "Confidentiality",
    },
    marquee: "TAX STRATEGY · WEALTH MANAGEMENT · LATAM · CORPORATE ADVISORY · STRUCTURING · COMPLIANCE ·",
    approach: {
      label: "The Manifesto",
      title: "An approach built on precision, not templates.",
      chapters: [
        { n: "01", t: "Deep diagnosis", d: "We analyze your current structure, flows and tax exposure before proposing a single line of strategy." },
        { n: "02", t: "Bespoke design", d: "Every administrative and tax structure is built around your wealth goals and your jurisdiction." },
        { n: "03", t: "Armored implementation", d: "We execute with strict regulatory compliance in every LATAM country where you operate." },
        { n: "04", t: "Continuous stewardship", d: "We don't hand over a document and disappear. We optimize your strategy quarter after quarter." },
      ],
    },
    services: {
      label: "Services",
      title: "Strategies that protect, organize and multiply your wealth.",
      items: [
        { t: "Tax Strategy", d: "Legal tax optimization, international tax planning and burden reduction in line with each jurisdiction's regulations." },
        { t: "Administrative Structure", d: "Process redesign, corporate governance and efficient corporate structures to operate frictionlessly across LATAM." },
        { t: "Compliance", d: "Risk prevention, regulatory obligations and compliant reporting before local and international authorities." },
        { t: "Wealth & Succession", d: "Asset protection, investment vehicles and succession planning to preserve the family legacy." },
      ],
    },
    reach: {
      label: "Regional Coverage",
      title: "One firm. All of Latin America.",
      body: "We operate with local knowledge across the region's main jurisdictions. Wherever your capital moves, our strategy follows.",
      countries: ["Mexico", "Colombia", "Chile", "Peru", "Argentina", "Brazil", "Panama", "Uruguay"],
    },
    payments: {
      label: "Payment Methods",
      title: "Settle fees and strategies with total flexibility.",
      body: "We accept multiple international payment methods. Choose the one that best fits your operation.",
      cards: {
        t: "Cards",
        d: "We charge Visa, Mastercard and American Express through a secure payment link sent directly to you.",
        tag: "Via payment link",
      },
      wire: {
        t: "International Transfer",
        d: "We receive international transfers (SWIFT/Wire). We share full bank details once your strategy is confirmed.",
        tag: "SWIFT / Wire",
      },
      crypto: {
        t: "Cryptocurrencies",
        d: "We also charge in crypto. We accept the main networks and share the corresponding wallet address.",
        tag: "BTC · ETH · USDT",
      },
      note: "* All payments are processed privately once the strategy scope is confirmed. This section is informational only.",
    },
    contact: {
      label: "Contact",
      title: "Begin your strategy.",
      body: "Tell us about your situation. A senior FLODELICA advisor will reach out confidentially.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Address",
      address: "Calle 32 Ext. 269, Col. Montes de Amé, Mérida, Yucatán, C.P. 97115",
      intlNote: "We take international calls from anywhere in LATAM and worldwide.",
      phone: "+52 999 592 7397",
      phoneHref: "+529995927397",
      emailValue: "info@flodelicafiscal.com",
      name: "Full name",
      email: "Email address",
      country: "Country",
      company: "Company (optional)",
      service: "Service of interest",
      selectService: "Select a service",
      message: "Tell us about your goal",
      submit: "Send request",
      sending: "Sending...",
      success: "Request sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      services: ["Tax Strategy", "Administrative Structure", "Compliance", "Wealth & Succession"],
    },
    footer: {
      tagline: "Administrative and tax strategy for wealth without borders.",
      rights: "All rights reserved.",
      confidential: "Private advisory firm · LATAM",
      pay: "Accepted payments",
      terms: "Terms & Conditions",
      privacy: "Privacy Notice",
    },
  },
};
